export default __webpack_public_path__ + "static/media/contacts.63d5086b.svg";